import React from "react";
import gps from "../../../assets/icons/about-small-gps.svg";
import mail from "../../../assets/icons/contacts-mail.svg";
import phone from "../../../assets/icons/contacts-phone.svg";
import hour from "../../../assets/icons/pickup-hours.svg";

const ContactsInfo = ({ contacts }) => {
  return (
    <div className='contacts-info-info'>
      <h2 className='contacts-subtitle'>Производство. Склад. Офис.</h2>
      <div className='contacts-info__top'>
        <div className='contacts-info__card'>
          <img loading="lazy" className='contacts-info__image' src={gps} alt='Gps' />
          <address className='contacts-info__subtitle'>
            {contacts.address}
          </address>
        </div>
        <div className='contacts-info__card'>
          <img loading="lazy" className='contacts-info__image' src={mail} alt='Mail' />
          <p className='contacts-info__subtitle'>{contacts.email}</p>
        </div>
      </div>
      <div className='contacts-info__bottom'>
        <div className='contacts-info__card'>
          <img loading="lazy" className='contacts-info__image' src={phone} alt='Phone' />
          <p className='contacts-info__subtitle'>{contacts.phone}</p>
        </div>
        <div className='contacts-info__card'>
          <img loading="lazy" className='contacts-info__image' src={hour} alt='Hour' />
          <p className='contacts-info__subtitle'>
            {contacts.working_days_and_hours}
          </p>
        </div>
      </div>
      <div className='contacts-links'>
        <div className='contacts-link1-js'>
          <a
            className='contacts-links__item-first'
            download=''
            target='__blank'
            href={contacts.driving_scheme}
          >
            <div className='contacts-links__image'></div>
            <p className='contacts-links__title'>Схема проезда</p>
          </a>
        </div>
        <div className='contacts-link2-js'>
          <a
            className='contacts-links__item-second'
            download=''
            target='__blank'
            href={contacts.company_bank_details}
          >
            <div className='contacts-links__image'></div>
            <p className='contacts-links__title'>Реквизиты компании</p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactsInfo;
